import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { withConfig } from 'src/withConfig';

export const LogoGroup = styled(`div`, { label: 'LogoGroup' })`
    display: flex;
    gap: 8px;
    margin-top: auto;
    padding: 16px;
`;

const setTypeContainerColor = (type: 'primary' | 'secondary', theme: EmotionTheme): SerializedStyles => {
    if (type === 'primary') {
        return css`
            color: ${theme.star.iconContainer.iconColor};
            background: ${theme.star.iconContainer.bgColor};
        `;
    };
    return css`
        color: ${theme.star.iconContainer.iconColorSecondary};
        background: ${theme.star.iconContainer.bgColorSecondary};
    `;
};

interface LogoContainerStyledType {
    type: 'primary' | 'secondary';
}

export const LogoContainerStyled = withConfig(theme => styled(Link, { label: 'LogoContainerStyled' })<LogoContainerStyledType>`
    ${({ type }): SerializedStyles => setTypeContainerColor(type, theme)};
    align-items: center;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 56px;
    justify-content: center;
    width: 100%;
`);

